// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__rKj6p","errorLogs":"styles_errorLogs__3evpB"};